module.exports = __webpack_public_path__ + "static/img/03.5416c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/horse/03.png
// module id = LDdA
// module chunks = 1